module.exports = __webpack_public_path__ + "static/media/VJ.a50f5308.png";